import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MatIcon } from '@angular/material/icon';

// Sits directly below app-page-header on the Contacts and Organisations admin pages, letting an
// admin switch between them without going back through the side menu — see
// "Organisation tab in the contact page with header.png" / DEV-1192-context.md. Deliberately not
// used on the Users page: only Contacts/Organisations are treated as one "Contact Administration"
// surface in the design.
@Component({
  selector: 'app-admin-tabs',
  standalone: true,
  imports: [RouterLink, MatIcon],
  templateUrl: './admin-tabs.component.html',
  styleUrl: './admin-tabs.component.scss'
})
export class AdminTabsComponent {
  @Input({ required: true }) active!: 'contacts' | 'organisations';
  // null while the count hasn't loaded yet — rendered as an empty badge rather than a
  // momentarily-wrong "0".
  @Input() contactsCount: number | null = null;
  @Input() organisationsCount: number | null = null;
  // Fired when the already-active tab is clicked again — routerLink alone is a no-op in that case
  // (same URL, no navigation), which left pages that switch to an internal "detail" view (e.g.
  // Organisations' master-detail — see organisations.component.ts) with no way to get back to
  // their listing via this tab.
  @Output() reselect = new EventEmitter<'contacts' | 'organisations'>();

  onTabClick(tab: 'contacts' | 'organisations') {
    if (tab === this.active) {
      this.reselect.emit(tab);
    }
  }
}
